<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.reports'), $t('reports.costProfit')]">
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="100px"
      >
        <el-form-item
          :label="$t('delivery.deliverAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.deliverAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="daterangeValue"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-form-item :label="$t('text.ownerName')">
          <el-checkbox-group v-model="searchForm.ownerIds">
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('user.shop')">
          <el-checkbox-group v-model="searchForm.shopIds">
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
            <span v-if="count != null" class="pager-total">
              {{ count.productNoQty }} 款 {{ count.qtyTotal }} 件,总产品成本:{{
                count.productCost | currency
              }},总发货成本:{{ count.deliverCost | currency }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('order.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div class="font10">{{ row.innerSerialNo }}</div>
            <div class="font10">
              <state-label :state="row.workflowState">
                {{ $t("orderStates." + row.workflowState) }}
              </state-label>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="70"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('order.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.price }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="extraCharge"
          :title="$t('order.extraCharge')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.extraCharge }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="amount"
          :title="$t('bargain.amount')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.amount }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productCostAmount"
          :title="$t('monthSettlement.productCost')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.productCostAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deliverCostAmount"
          :title="$t('monthSettlement.deliverCost')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.deliverCostAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('order.dealType')" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.dealType !== null">{{
              $t("orderDealTypes." + row.dealType)
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deliverAt"
          :title="$t('delivery.deliverAt')"
          min-width="110"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('user.shop')"
          min-width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.ownerName')"
          min-width="80"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Currency from "@/components/Currency";
import User from "@/api/user";
import Shop from "@/api/shop";
import BackOrder from "@/api/backOrder";

export default {
  mixins: [page, table.pager, table.search],
  components: { Currency },
  data() {
    return {
      daterangeValue: [],
      searchForm: {
        deliverAtStartAt: null,
        deliverAtEndAt: null,
        shopIds: [],
        ownerIds: [],
      },
      users: [],
      shops: [],
      payMethods: [],
      //
      records: [],
      loading: false,
      count: null,
      actionPageDF: false,
    };
  },

  created() {
    const self = this;
    if (self.$route.query && self.$route.query.settleAt !== undefined) {
      self.daterangeValue = [
        new Date(Util.reportStartAt(self.$route.query.settleAt)),
        new Date(Util.reportEndAt(self.$route.query.settleAt)),
      ];
      self.loadData();
    }
    axios.all([Shop.findByTenantId(), User.findByTenantId()]).then(
      axios.spread(function (shops, users) {
        if (shops.status == 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        if (users.status == 200) {
          self.users = users.data.filter(
            (u) => (u.voidAt == null && u.authorize == true) || u.voidAt != null
          );
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    //
    download() {
      const self = this;
      if (self.daterangeValue == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("delivery.deliverAt")]),
          type: "warning",
        });
        return;
      }
      self.searchForm.deliverAtStartAt = Util.formatDateTime(
        this.daterangeValue[0]
      );
      self.searchForm.deliverAtEndAt = Util.formatDateTime(
        this.daterangeValue[1]
      );
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      BackOrder.costProfitReportExportExcel(self.combineParams()).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.checkedRows = [];
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        }
      );
    },
    //
    loadData() {
      const self = this;
      if (self.daterangeValue == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("delivery.deliverAt")]),
          type: "warning",
        });
        return;
      }
      self.searchForm.deliverAtStartAt = Util.formatDateTime(
        this.daterangeValue[0]
      );
      self.searchForm.deliverAtEndAt = Util.formatDateTime(
        this.daterangeValue[1]
      );
      self.loading = true;
      BackOrder.costProfitReport(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data.records;
          self.pager.total = res.data.total;
          self.getTotal();
        } else {
          self.sysError();
        }
      });
    },
    getTotal() {
      const self = this;
      if (self.actionPageDF) {
        return;
      }
      BackOrder.costProfitReportCount(self.combineParams()).then(function (
        res
      ) {
        self.loading = false;
        if (res.status === 200) {
          self.count = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    changePager(params) {
      this.pager.currentPage = params.currentPage;
      this.pager.pageSize = params.pageSize;
      this.actionPageDF = true;
      this.loadData();
    },
    combineParams() {
      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>